export enum AttendanceWindowType {
	Chat,
	Notes,
	Documents,
	Booking,
	VideoCall,
	TriageAnswer
}